export default {
  token: (state) => state.auth.access_token,
  user: (state) => state.auth.user,
};
